/**
 * Mirrors options-backend's src/utils/dateFormatCatalog.ts. Keys must stay in
 * sync — the backend resolves these keys into the actual Excel/strftime
 * patterns, this side only needs the date-fns token to render a live preview.
 */
export type DateFormatKey =
  | "DD_MMM_YYYY"
  | "DD_MM_YYYY"
  | "MM_DD_YYYY"
  | "YYYY_MM_DD"
  | "DD_SLASH_MMM_YYYY"
  | "DD_DOT_MM_YYYY"
  | "MMM_DD_YYYY";

export interface DateFormatOption {
  key: DateFormatKey;
  label: string;
  dateFnsFormat: string;
}

export const DEFAULT_DATE_FORMAT_KEY: DateFormatKey = "DD_MMM_YYYY";

export const DATE_FORMAT_OPTIONS: DateFormatOption[] = [
  { key: "DD_MMM_YYYY", label: "DD-MMM-YYYY", dateFnsFormat: "dd-MMM-yyyy" },
  { key: "DD_MM_YYYY", label: "DD/MM/YYYY", dateFnsFormat: "dd/MM/yyyy" },
  { key: "MM_DD_YYYY", label: "MM/DD/YYYY", dateFnsFormat: "MM/dd/yyyy" },
  { key: "YYYY_MM_DD", label: "YYYY-MM-DD", dateFnsFormat: "yyyy-MM-dd" },
  {
    key: "DD_SLASH_MMM_YYYY",
    label: "DD/MMM/YYYY",
    dateFnsFormat: "dd/MMM/yyyy",
  },
  { key: "DD_DOT_MM_YYYY", label: "DD.MM.YYYY", dateFnsFormat: "dd.MM.yyyy" },
  {
    key: "MMM_DD_YYYY",
    label: "MMM DD, YYYY",
    dateFnsFormat: "MMM dd, yyyy",
  },
];
